module.exports = __webpack_public_path__ + "img/next-steps-mob.699770b5.webp";